import Cookies from 'universal-cookie'
import { safeParseJSON } from '../utils'

const cookies = new Cookies()

export const getSideMenuStore = () => safeParseJSON(localStorage.getItem('sideMenu'), {})
export const setSideMenuStore = (params = {}) => {
  localStorage.setItem(
    'sideMenu',
    JSON.stringify({
      ...getSideMenuStore(),
      ...params,
    })
  )
}

export const setCurrentAppStore = (currentApp = {}) => {
  localStorage.setItem('currentApp', JSON.stringify(currentApp))
}
export const getCurrentAppStore = () => safeParseJSON(localStorage.getItem('currentApp'), {})

export const setCurrentOrgStore = (currentOrg = {}) => {
  localStorage.setItem('currentOrg', JSON.stringify(currentOrg))
}
export const getCurrentOrgStore = () => safeParseJSON(localStorage.getItem('currentOrg'), {})

export const setCurrentOrgTreeStore = (currentOrgTree = []) => {
  localStorage.setItem('currentOrgTree', JSON.stringify(currentOrgTree))
}
export const getCurrentOrgTreeStore = () =>
  safeParseJSON(localStorage.getItem('currentOrgTree'), [])

// export const setLanguageStore = (lang) => localStorage.setItem('lang', lang)
// export const getLanguageStore = () => localStorage.getItem('lang')
export const setLanguageStore = (lang) => cookies.set('lang', lang, { path: '/' })
export const getLanguageStore = () => cookies.get('lang', { path: '/' })

export const setThemeStore = (theme) => localStorage.setItem('theme', theme)
export const getThemeStore = () => localStorage.getItem('theme')

export const clearLoginCookie = () => {
  cookies.remove('_td_token_', { path: '/' })
  cookies.remove('_uid_', { path: '/' })
}
